
export const RECIPIENT_NAME_MAX_LENGTH = 50;
export const MIN_AMOUNT_BANK = 10;
export const MIN_AMOUNT_MPESA = 1;
export const MAX_AMOUNT = 250000;
export const REMARKS_MAX_BANK = 70;
export const REMARKS_MAX_MPESA = 200;

export const recipientValidators = {
  recipientName: (v) => {
    if (!v?.trim()) return "Recipient name is required";
    if (v.trim().length > RECIPIENT_NAME_MAX_LENGTH) {
      return `Recipient name must be ${RECIPIENT_NAME_MAX_LENGTH} characters or less`;
    }
    return null;
  },
  phoneNumber: (v) => {
    if (!v?.trim()) return "Phone number is required";
    return /^254[71]\d{8}$/.test(v.trim())
      ? null
      : "Must be a valid 12-digit Kenyan number starting with 2547 or 2541";
  },
  bankCode: (v) => (v?.trim() ? null : "Please select a bank"),
  accountNumber: (v) => {
    if (!v?.trim()) return "Account number is required";
    const trimmed = v.trim();
    if (!/^\d+$/.test(trimmed)) return "Account number must contain digits only";
    if (trimmed.length < 8 || trimmed.length > 20) {
      return "Account number must be between 8 and 20 digits";
    }
    return null;
  },
  amount: (v, isBank, limits) => {
    if (!v && v !== 0) return "Amount is required";
    if (!Number.isInteger(v)) return "Amount must not contain decimal places";
    const min = limits?.minAmount ?? MIN_AMOUNT_BANK;
    const max = limits?.maxAmount ?? MAX_AMOUNT;
    if (v < min) return `Amount must be at least KES ${min.toLocaleString()}`;
    if (v > max) return `Amount cannot exceed KES ${max.toLocaleString()}`;
    return null;
  },
  remarks: (v, isBank) => {
    if (!v?.trim()) return "Remarks is required";
    const maxLength = isBank ? REMARKS_MAX_BANK : REMARKS_MAX_MPESA;
    if (v.trim().length > maxLength) {
      return `Remarks must be ${maxLength} characters or less`;
    }
    return null;
  },
};
